export enum SectionAnchor {
  Index = 'index',
  Solutions = 'solutions',
  Services = 'services',
  Benefits = 'benefits',
  Company = 'company',
  Contacts = 'contacts',
}
